import { render } from "./SubcategoryTagPage.vue?vue&type=template&id=02441f83"
import script from "./SubcategoryTagPage.vue?vue&type=script&lang=js"
export * from "./SubcategoryTagPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__